<template>
    <div class="additional-service-help">
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <main class="main-box main-box_white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col col-lg-8">
                        <div class="content-box">
                            <div class="search-box search-box_vidinis">
                                <div class="input-group input-group-lg">
                                    <input type="text" class="form-control" aria-label="Large" aria-describedby="inputGroup-sizing-sm">
                                </div>
                            </div>
                            <div class="row bar-wrap">
                                <div class="col-md-3">
                                    <aside class="sidebar">
                                        <ul class="sidebar-nav">
                                            <li class="active"><a href="#">Kas yra BOXITI?</a></li>
                                            <li><a href="#">Inventorius</a></li>
                                            <li><a href="#">Sandėliavimas</a></li>
                                            <li><a href="#">Užsakymai</a></li>
                                            <li><a href="#">Pristatymo paslaugos</a></li>
                                            <li><a href="#">Kaina ir apmokėjimas</a></li>
                                        </ul>
                                    </aside>
                                </div>
                                <div class="col-md-9">
                                    <div class="content border-left">
                                        <h3 class="article-title">Su kokiomis platformomis susieta Boxiti sistema?</h3>
                                        <p>Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum
                                            naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto
                                            dubliavimo: </p>
                                        <br>
                                        <p>„Tekstas tekstas tekstas tekstas...“. Daugelis leidybinių sistemų programų, o taip pat ir Hiperteksto
                                            kalbos redaktoriai naudoja Lorem Ipsum kaip demonstracinę numatyto teksto versiją, todel žodžių „Lorem
                                            Ipsum“ internetinė paieška parodo daug tinklalapių kurie yra <b>dar besikuriantys. Egzistuoja ne mažai
                                                įvairių Lorem Ipsum versijų. Kai kurios</b> iš jų buvo sukurtos per klaidą, kitos - tyčia (pvz.
                                            jumoristinės).</p>
                                        <br>
                                        <p>Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum
                                            naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto
                                            dubliavimo: </p>
                                        <p class="small-m">1.) Kad vertinant dizainą ir kompoziciją,</p>
                                        <p class="small-m">2.) Raidžių paskirstymą vietoje <b>CTRL + V</b> paprasto dubliavimo</p>
                                        <p class="small-m">3.) Tad Lorem <b>Ipsum naudojamas tam</b></p>
                                        <p><b>Egzistuoja ne mažai įvairių Lorem Ipsum versijų. Kai kurios iš jų buvo</b></p>
                                        <!-- TODO:  Waiting for video -->
                                        <div class="iframe-responsive d-none">
                                            <iframe width="100%" height="auto" src="https://www.youtube.com/embed/2ccaHpy5Ewo?ecver=1"
                                                    frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div class="form-container-line"></div>
                                        <p><b>Ar ši informacija buvo naudinga?</b></p>
                                        <button class="btn btn-accent content-btn">Taip</button>
                                        <button class="btn btn-accent content-btn">Ne</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <div class="main-box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6 offset-lg-2 col-md-9 offset-md-3">
                        <div class="content-description">
                            <div class="card card_transparent">
                                <div class="card-body">
                                    <ul>
                                        <li>Pažintinis video – ar jame bus apie inventoriaus planavimą?</li>
                                        <li>Kokias paslaugas teikiate?</li>
                                        <li><b>Su kokiomis platformomis susieta Boxiti sistema?</b></li>
                                        <li>Ar galiu integruoti daugiau nei vieną savo parduotuvę?</li>
                                        <li>Kiek kainuoja prijungti savo parduotuvę?</li>
                                        <li>Ar siūlote ir svetainės API integraciją?</li>
                                        <li>Ar mano duomenys yra saugūs? Your data is fully backed up on secure data centers using 256-bit
                                            encryption.
                                        </li>
                                        <li>Ar reikalinga ilgalaikė bendradarbiavimo sutartis? Our services require no commitments or long term
                                            contracts. You are free to close your account at any time; all we ask is 30 days notice for inventory
                                            retrieval.
                                        </li>
                                        <li>Kaip pradėti naudotis paslaugomis?</li>
                                        <li>Kaip pradėti naudotis paslaugomis?</li>
                                        <li>Ar priimate grąžinimus iš klientų?</li>
                                        <li>Kokias papildomas paslaugas teikiate? Prekių žymėjimas lipdukais?</li>
                                        <li>Ar galite pridėti mano PVM sąskaitą-faktūrą prie užsakymo?</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'AdditionalServiceHelp'
    }
</script>

<style lang="scss" scoped>
    footer {
        padding-top: 55px;

        @media (max-width: 575.98px) {
            padding-top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Public/AdditionalServiceHelp.vue